import { graphql } from '@/generated/gql';

export const SOURCING_CASE_CANCELLED_ALERT_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseCancelledAlert($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        id
        status
        cancellationReason
        cancellationReasonText
      }
    }
  }
`);
